<template>
    <div class="wallet-box">
      <div class="wallet-box-top">
          <div class="recharge-list">
            <div class="recharge-item">
                  <div class="item-left">
                      <div class="icon">
                          <img src="@/assets/index/img/ucenter/wallet/wallet_remain_amount.svg" alt="">
                      </div>
                  </div>
                  <div class="item-right">
                      <div class="info">
                          <div class="money green"><span class="unit">$</span><span class="amount"  v-cloak>{{ formatMoney(walletInfo.remaining) }}</span>
                          </div>
                          <div class="tip"></div>
                      </div>
                      <div class="tit">{{ walletInfo.remaining > 0 ? $t('wallet_settings.remaining') : $t('wallet_settings.overdraft') }}</div>
                  </div>
              </div>
              <div class="recharge-item">
                  <div class="item-left">
                      <div class="icon">
                          <img src="@/assets/index/img/ucenter/wallet/wallet_total_recharge_amount.svg" alt="">
                      </div>
                  </div>
                  <div class="item-right">
                      <div class="info">
                          <div class="money blue"><span class="unit">$</span><span class="amount"  v-cloak>{{ formatMoney(walletInfo.total) }}</span>
                          </div>
                          <div class="tip"></div>
                      </div>
                      <div class="tit">{{ $t('wallet_settings.total') }}</div>
                  </div>
              </div>
              <div class="recharge-item">
                  <div class="item-left">
                      <div class="icon">
                          <img src="@/assets/index/img/ucenter/wallet/wallet_usage_amount.svg" alt="">
                      </div>
                  </div>
                  <div class="item-right">
                      <div class="info">
                          <div class="money orange"><span class="unit">$</span><span class="amount"  v-cloak>{{ formatMoney(walletInfo.use) }}</span>
                          </div>
                          <div class="tip"></div>
                      </div>
                      <div class="tit">{{ $t('wallet_settings.usage') }}</div>
                  </div>
              </div>
              <div class="recharge-item" :class="showCreditBalance ? 'visible' : 'invisible'">
                  <div class="item-left">
                      <div class="icon">
                          <img src="@/assets/index/img/ucenter/wallet/wallet_credit_amount.png" alt="">
                      </div>
                  </div>
                  <div class="item-right">
                      <div class="info">
                          <div class="money yellow"><span class="unit">$</span><span class="amount"  v-cloak>{{ formatMoney(walletInfo.creditBalance) }}</span>
                          </div>
                          <div class="tip"></div>
                      </div>
                      <div class="tit">{{ $t('wallet_settings.credit') }}</div>
                  </div>
              </div>
          </div>
      </div>
      <div class="deposit-box">
          <div class="deposit-box-title">
            {{ $t('wallet_settings.recharge.title') }}
          </div>
          <div class="deposit-num">
              <div class="num">
                  <el-input-number v-model="depositNum" @change="handleChange" :min="1" :max="maxDepositNum" label="">
                  </el-input-number>
              </div>
              <div class="tip">
                {{ $t('wallet_settings.recharge.tips') }}
              </div>
          </div>
          <div class="deposit-slider">
              <el-slider v-model="depositNum" :min="5" :max="maxDepositNum"></el-slider>
          </div>
          <div class="deposit-btns">
              <div class="deposit-add-btns">
                  <div class="add-btn" @click="changeDepositNum(10)">+ $10</div>
                  <div class="add-btn" @click="changeDepositNum(50)">+ $50</div>
                  <div class="add-btn" @click="changeDepositNum(100)">+ $100</div>
                  <div class="add-btn" @click="changeDepositNum(500)">+ $500</div>
                  <div class="add-btn" @click="changeDepositNum(1000)">+ $1000</div>
              </div>
              <div class="deposit-pay-btn">
                  <div class="pay-btn" @click="walletRecharge">{{ $t('wallet_settings.action') }}</div>
              </div>
          </div>
      </div>
      <PaymentView v-if="showPaymentView" @close="showPaymentView = false" ref="paymentView"></PaymentView>
    </div>
</template>

<script>
import { getWalletInfo, getUserAuthorities } from '@/http/api/member'
import PaymentView from "@/views/payment/payment-view.vue"

export default {
  name: 'wallet-info',
  components: {
    PaymentView,
  },

  data() {
    return {
      showPaymentView: false,

      showCreditBalance: false,
      walletInfo:{
          total:0,
          use:0,
          remaining:0,
          creditBalance: 0,
      },
      maxDepositNum:10000,
      depositNum: 100,

      dragOptions: {
          animation: 500,
          filter: '.disabled',
      },
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin
    },
  },
  inject: ['updateCurrentMenuUrl'],
  created() {
    this.updateCurrentMenuUrl('/ucenter/wallet/');
  },
  mounted() {
    this.getWalletInfo();
    this.loadUserAuthories()
  },
  
  methods: {
    formatMoney(value) {
      const amount = Number(value)
      if (!Number.isFinite(amount)) {
        return '0'
      }

      const rounded = Math.round((amount + Number.EPSILON) * 100) / 100
      return String(Object.is(rounded, -0) ? 0 : rounded)
    },
    handleChange: function (currentValue, oldValue) {
      if(currentValue > this.maxDepositNum){
        currentValue = this.maxDepositNum
      }else if(currentValue < 1){
        currentValue = this.maxDepositNum
      }
      this.depositNum = currentValue
    },
    changeDepositNum:function(data){
      let num = this.depositNum
      num += data
      
      if(num > this.maxDepositNum){
          num = this.maxDepositNum
      }else if(num < 1){
          num = this.maxDepositNum
      }
      this.depositNum = num
    },
    walletRecharge:function(){
      var that = this
      if (that.isLogin) {
        let item = {
          deposit: that.depositNum,
          currency: 'USD',
          source: '/ucenter/wallet/',
        }
        that.showPaymentView = true;
        that.$nextTick(() => {
          if (that.$refs.paymentView) {
            that.$refs.paymentView.updateInfo(item)
          }
        })
      } else {
        this.$router.push({path:'/login', query: {redirect: this.$route.fullPath}})
      }
    },
    getWalletInfo:function(){
      var that = this
      getWalletInfo().then(res => {
        let wallet_info = res.data
            
        that.walletInfo.total = wallet_info.total_charged
        that.walletInfo.use = wallet_info.total_spend
        that.walletInfo.remaining = wallet_info.balance
        that.walletInfo.creditBalance = wallet_info.credit_balance
      }).catch(e => {
        // that.$message.error(e.message ?? e.msg ?? "get wallet info error");
      });
    },
    async loadUserAuthories() {
      let that = this;
      await getUserAuthorities({}).then((res) => {
        if (res.data.show_credit_balance == 1) {
            that.showCreditBalance = res.data.show_credit_balance;
            that.maxDepositNum = 1 * res.data.max_charge_amount;
        }
      }).catch(e => {
        // that.$message.error(e.message ?? e.msg ?? "get user authorities error");
      }).finally(() => {
        that.loading = false;
      })
    },
  }
}

</script>

<style lang="scss" scoped>
.wallet-box {
    width: 100%
}

.wallet-box .wallet-box-top {
    width: 100%;
    margin-bottom: 28px;
    padding: 22px;
    box-sizing: border-box;
    border: 1px solid #D5DDF9;
    border-radius: 10px;
    background: #FFFFFF;
    box-shadow: 0px 6px 24px rgba(34, 50, 101, 0.06)
}

.wallet-box .wallet-box-top .recharge-list {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px
}

.wallet-box .wallet-box-top .recharge-list .recharge-item {
    flex: 1 1 240px;
    min-width: 220px;
    height: 148px;
    margin-bottom: 0;
    padding: 28px 16px 28px 28px;
    background: #F8FAFF;
    border: 1px solid rgba(213, 221, 249, 0.72);
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-left {
    margin-right: 23px
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-left .icon {
    width: 39px;
    height: 39px
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-right {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-right .info .money {
    font-size: 42px;
    font-family: "Poppins-Medium";
    color: #276DFD;
    line-height: 0.9
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-right .info .money.blue {
    color: #276DFD
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-right .info .money.yellow {
    color: #f2b96e
}


.wallet-box .wallet-box-top .recharge-list .recharge-item .item-right .info .money.orange {
    color: #FFA32E
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-right .info .money.green {
    color: #10C158
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-right .info .tip {
    margin-top: 12px;
    font-size: 12px;
    font-family: "Poppins";
    font-weight: 400;
    color: #9599AD;
    line-height: 0.9
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-right .tit {
    font-size: 18px;
    font-family: "Poppins";
    font-weight: 500;
    color: #223265;
    line-height: 0.9
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-tip {
    position: absolute;
    top: 30px;
    right: 15px
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-tip .tip-icon {
    position: relative;
    cursor: pointer
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-tip .tip-icon img {
    width: 16px;
    height: 16px
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-tip .tip-icon .tip-txt {
    display: none;
    position: absolute;
    right: -10px;
    top: -10px;
    transform: translateY(-100%);
    padding: 7px 10px;
    background: #FFFFFF;
    box-shadow: 0px 0px 12px 0px #C7C8C9;
    border-radius: 4px;
    font-size: 12px;
    font-family: "Poppins-Light";
    font-weight: 400;
    color: #9599AD;
    white-space: nowrap;
    line-height: 1;
    cursor: default
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-tip .tip-icon .tip-txt::after {
    content: '';
    position: absolute;
    bottom: -14px;
    right: 12px;
    width: 0;
    height: 0;
    border-width: 7px;
    border-style: solid;
    border-color: #fff transparent transparent transparent
}

.wallet-box .wallet-box-top .recharge-list .recharge-item .item-tip .tip-icon:hover .tip-txt {
    display: block
}

.wallet-box .deposit-box {
    width: 100%;
    margin-bottom: 59px;
    padding: 26px 47px 46px;
    box-sizing: border-box;
    border: 1px solid #D5DDF9;
    border-radius: 10px
}

.wallet-box .deposit-box .deposit-box-title {
    margin-bottom: 15px;
    height: 27px;
    font-size: 24px;
    font-family: "Poppins-Medium";
    color: #223265;
    line-height: 27px
}

.wallet-box .deposit-box .deposit-num {
    margin-bottom: 23px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end
}

.wallet-box .deposit-box .deposit-num .tip {
    margin-left: 17px;
    font-size: 14px;
    font-family: "Poppins-Light";
    font-weight: 300;
    color: #A9AFB7
}

.wallet-box .deposit-box .deposit-slider .el-slider .el-slider__runway .el-slider__button-wrapper .el-slider__button {
    width: 22px;
    border-radius: 10px;
    background-image: url("@/assets/index/img/ucenter/wallet/slider_bg.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
    background-color: #fff
}

.wallet-box .deposit-box .deposit-btns {
    width: 100%;
    margin-top: 25px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center
}

.wallet-box .deposit-box .deposit-btns .deposit-add-btns {
    display: flex;
    justify-content: flex-start
}

.wallet-box .deposit-box .deposit-btns .deposit-add-btns .add-btn {
    margin-right: 12px;
    padding: 8px 9px;
    border: 2px solid #E4E4E4;
    border-radius: 4px;
    font-family: "Poppins-Light";
    font-size: 15px;
    color: #3174FC;
    line-height: 1;
    cursor: pointer
}

.wallet-box .deposit-box .deposit-btns .deposit-add-btns .add-btn:hover {
    color: #fff;
    background-color: #3174FC;
    border-color: #3174FC
}

.wallet-box .deposit-box .deposit-btns .deposit-add-btns .add-btn:last-of-type {
    margin-right: 0
}

.wallet-box .deposit-box .deposit-btns .deposit-pay-btn .pay-btn {
    padding: 15px 65px;
    background: #3174FC;
    border-radius: 4px;
    font-size: 16px;
    font-family: "Poppins-SemiBold";
    line-height: 1;
    font-weight: 500;
    color: #FEFEFF;
    cursor: pointer
}
</style>
